import { useDispatch } from 'react-redux';

import {
	SET_FORM_STATE,
	RESET_FIELDS,
	// Map
	SET_SELECTED_UTILIZATION_DATE,
	GET_FAILURES_FILTERS,
	GET_FAILURES_VOICE,
	GET_FAILURES_PACKET,
	GET_DRIVETESTS_CITIES,
	GET_DRIVETESTS_DRIVES,
	GET_DRIVETESTS_DATES,
	SET_SELECTED_DATES,
	GET_DRIVETEST,
	GET_TOPOLOGY_2G,
	GET_TOPOLOGY_3G,
	GET_TOPOLOGY_4G,
	GET_TOPOLOGY_5G,
	// Map Compare
	SET_SELECTED_TRAFFIC_PCT_ADD,
	SET_SELECTED_UTILIZATION_DATE_COMPARE,
	GET_FAILURES_FILTERS_COMPARE,
	GET_FAILURES_VOICE_COMPARE,
	GET_FAILURES_PACKET_COMPARE,
	GET_DRIVETESTS_CITIES_COMPARE,
	GET_DRIVETESTS_DRIVES_COMPARE,
	GET_DRIVETESTS_DATES_COMPARE,
	SET_SELECTED_DATES_COMPARE,
	GET_DRIVETEST_COMPARE,
	GET_TOPOLOGY_2G_COMPARE,
	GET_TOPOLOGY_3G_COMPARE,
	GET_TOPOLOGY_4G_COMPARE,
	GET_TOPOLOGY_5G_COMPARE,
	// Global
	GET_TRAFFIC_PCT_ADD_OPTIONS,
	GET_UTILIZATION_DATES,
	TOGGLE_FILTERS,
	CLEAR_FORM,
	TOGGLE_CARRIERS_COLORS_DIALOG,
	GET_CARRIERS_COLORS,
	GET_SITES_IDS,
	GET_SITE_ID_LOCATION,
	TOGGLE_CARRIERS_COLORS_PICKER_DIALOG,
} from '../actions/DualMapActions';

const initialState = {
	// Map
	selectedUtilizationDate: '',
	failuresFilters: [],
	failuresVoice: [],
	failuresPacket: [],
	cities: [],
	drives: [],
	dates: [],
	selectedDates: [],
	driveTest: [],
	topology2gData: [],
	topology3gData: [],
	topology4gData: [],
	topology5gData: [],
	topologyLabelsData: [],
	techBandVoice: [],
	techBandPacket: [],
	// Map Compare
	selectedTrafficPctAdd: '0',
	selectedUtilizationDateCompare: '',
	failuresFiltersSideCompare: [],
	failuresVoiceCompare: [],
	failuresPacketCompare: [],
	drivesCompare: [],
	datesCompare: [],
	selectedDatesCompare: [],
	driveTestCompare: [],
	topology2gDataCompare: [],
	topology3gDataCompare: [],
	topology4gDataCompare: [],
	topology5gDataCompare: [],
	topologyLabelsDataCompare: [],
	techBandVoiceCompare: [],
	techBandPacketCompare: [],
	// Global
	// colorChangesArray: [],
	trafficPctAddOptions: [],
	utilizationDates: [],
	openFilters: false,
	carriersColorsDialogVisibility: false,
	carriersColorsPickerDialogVisibility: false,
	sitesIds: [],
	siteIdLocation: [],
	carriersColors: [],
	currentColorCode: 'white',
	formState: {
		isValid: false,
		values: {
			// Map
			selectedDate: '',
			selectedCity: '',
			selectedDrive: '',
			voiceActive: false,
			packetActive: false,
			failureTypeVoice: 'all',
			failureTypePacket: 'all',
			cfn1LevelVoice: 'all',
			cfn1LevelPacket: 'all',
			mapAutoZoom: true,
			mapCompare: false,
			mapFrameSize: '80vw',
			mapSync: true,
			mapFilters: true,
			mapSize: 10,
			// Map Compare
			selectedCityCompare: '',
			selectedDriveCompare: '',
			voiceActiveCompare: false,
			packetActiveCompare: false,
			techBandVoiceActiveCompare: false,
			techBandPacketActiveCompare: false,
			failureTypeVoiceCompare: 'all',
			failureTypePacketCompare: 'all',
			cfn1LevelVoiceCompare: 'all',
			cfn1LevelPacketCompare: 'all',
		},
		touched: {},
		errors: {},
	},
};

const dualMapReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_SELECTED_UTILIZATION_DATE: {
						return {
							...state,
							selectedUtilizationDate: action.selectedUtilizationDate
						};
					}

					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: [],
						};
					}
					// Map
					case GET_FAILURES_FILTERS: {
						return {
							...state,
							failuresFilters: action.failuresFilters,
							formState: initialState.formState
						};
					}
					case GET_FAILURES_VOICE: {
						return {
							...state,
							failuresVoice: action.failuresVoice
						};
					}
					case GET_FAILURES_PACKET: {
						return {
							...state,
							failuresPacket: action.failuresPacket
						};
					}
					case GET_DRIVETESTS_CITIES: {
						return {
							...state,
							cities: action.cities
						};
					}
					case GET_DRIVETESTS_DRIVES: {
						return {
							...state,
							drives: action.drives
						};
					}
					case GET_DRIVETESTS_DATES: {
						return {
							...state,
							dates: action.dates
						};
					}
					case SET_SELECTED_DATES: {
						return {
							...state,
							selectedDates: action.selectedDates
						};
					}
					case GET_DRIVETEST: {
						return {
							...state,
							driveTest: action.driveTest
						};
					}
					case GET_TOPOLOGY_2G: {
						return {
							...state,
							topology2gData: action.topology2gData,
							topologyLabelsData: action.topology2gData.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_3G: {
						return {
							...state,
							topology3gData: action.topology3gData,
							topologyLabelsData: action.topology3gData.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_4G: {
						return {
							...state,
							topology4gData: action.topology4gData,
							topologyLabelsData: action.topology4gData.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_5G: {
						return {
							...state,
							topology5gData: action.topology5gData,
							topologyLabelsData: action.topology5gData.topologyLabelsDto
						};
					}
					// Map Compare
					case SET_SELECTED_TRAFFIC_PCT_ADD: {
						return {
							...state,
							selectedTrafficPctAdd: action.selectedTrafficPctAdd
						};
					}
					case SET_SELECTED_UTILIZATION_DATE_COMPARE: {
						return {
							...state,
							selectedUtilizationDateCompare: action.selectedUtilizationDateCompare
						};
					}
					case GET_FAILURES_FILTERS_COMPARE: {
						return {
							...state,
							failuresFiltersSideCompare: action.failuresFiltersSideCompare,
							formState: initialState.formState
						};
					}
					case GET_FAILURES_VOICE_COMPARE: {
						return {
							...state,
							failuresVoiceCompare: action.failuresVoiceCompare
						};
					}
					case GET_FAILURES_PACKET_COMPARE: {
						return {
							...state,
							failuresPacketCompare: action.failuresPacketCompare
						};
					}
					case GET_DRIVETESTS_CITIES_COMPARE: {
						return {
							...state,
							citiesCompare: action.citiesCompare
						};
					}
					case GET_DRIVETESTS_DRIVES_COMPARE: {
						return {
							...state,
							drivesCompare: action.drivesCompare
						};
					}
					case GET_DRIVETESTS_DATES_COMPARE: {
						return {
							...state,
							datesCompare: action.datesCompare
						};
					}
					case SET_SELECTED_DATES_COMPARE: {
						return {
							...state,
							selectedDatesCompare: action.selectedDatesCompare
						};
					}
					case GET_DRIVETEST_COMPARE: {
						return {
							...state,
							driveTestCompare: action.driveTestCompare
						};
					}
					case GET_TOPOLOGY_2G_COMPARE: {
						return {
							...state,
							topology2gDataCompare: action.topology2gDataCompare,
							topologyLabelsDataCompare: action.topology2gDataCompare.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_3G_COMPARE: {
						return {
							...state,
							topology3gDataCompare: action.topology3gDataCompare,
							topologyLabelsDataCompare: action.topology3gDataCompare.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_4G_COMPARE: {
						return {
							...state,
							topology4gDataCompare: action.topology4gDataCompare,
							topologyLabelsDataCompare: action.topology4gDataCompare.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_5G_COMPARE: {
						return {
							...state,
							topology5gDataCompare: action.topology5gDataCompare,
							topologyLabelsDataCompare: action.topology5gDataCompare.topologyLabelsDto
						};
					}
					// Global
					case GET_TRAFFIC_PCT_ADD_OPTIONS: {
						return {
							...state,
							trafficPctAddOptions: action.trafficPctAddOptions
						};
					}
					case GET_UTILIZATION_DATES: {
						return {
							...state,
							utilizationDates: action.utilizationDates
						};
					}
					case TOGGLE_FILTERS: {
						return {
							...state,
							openFilters: action.openFilters
						};
					}
					case CLEAR_FORM: {
						return {
							...state,
							formState: initialState.formState
						};
					}
					case GET_SITES_IDS: {
						return {
							...state,
							sitesIds: action.sitesIds
						};
					}
					case GET_SITE_ID_LOCATION: {
						return {
							...state,
							siteIdLocation: action.siteIdLocation
						};
					}
					case TOGGLE_CARRIERS_COLORS_DIALOG: {
						return {
							...state,
							carriersColorsDialogVisibility: action.visible
						};
					}
					case TOGGLE_CARRIERS_COLORS_PICKER_DIALOG: {
						return {
							...state,
							carriersColorsPickerDialogVisibility: action.visible,
							tableIdColorCode: action.tableIdColorCode,
							currentColorCode: action.currentColorCode
						};
					}
					case GET_CARRIERS_COLORS: {
						return {
							...state,
							carriersColors: action.carriersColors
						};
					}
					default: {
						return state;
					}
	}
};

export default dualMapReducer;
